// extracted by mini-css-extract-plugin
export default {"root":"editable_booking_notes_root__cULTJ"};